export const USER_ROLES = ['admin', 'admin_client', 'client'] as const;

export type UserRole = (typeof USER_ROLES)[number];

const normalizeRoleString = (value: string | null | undefined): UserRole | null => {
  if (!value) {
    return null;
  }

  const normalized = value.trim().toLowerCase();
  return USER_ROLES.includes(normalized as UserRole) ? (normalized as UserRole) : null;
};

export const resolveUserRole = (
  user: { app_metadata?: Record<string, unknown>; user_metadata?: Record<string, unknown> } | null | undefined
): UserRole | null => {
  if (!user) {
    return null;
  }

  const candidates = [user.app_metadata?.role, user.user_metadata?.role];
  for (const candidate of candidates) {
    const resolved = normalizeRoleString(typeof candidate === 'string' ? candidate : null);
    if (resolved) {
      return resolved;
    }
  }

  return 'client';
};
